<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="primary accent-4"
      center-active
      dark
    >
      <v-tab href="#tab-1">
        我的客户
      </v-tab>

      <v-tab href="#tab-2">
        个人资料
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!--tab1-content-->
      <v-tab-item
        key="1"
        value="tab-1"
      >
        <v-container class="grey lighten-5">
          <v-row
            no-gutters
            style="flex-wrap: nowrap;"
          >
            <v-col
              cols="2"
              style="min-width: 500px; max-width: 100%;"
              class="flex-grow-0 flex-shrink-0"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                I'm 2 column wide
              </v-card>
            </v-col>
            <v-col
              cols="1"
              style="min-width: 500px; max-width: 100%;"
              class="flex-grow-1 flex-shrink-0"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                I'm 1 column wide and I grow to take all the space
              </v-card>
            </v-col>
            <v-col
              cols="5"
              style="min-width: 600px;"
              class="flex-grow-0 flex-shrink-1"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                I'm 5 column wide and I shrink if there's not enough space
              </v-card>
            </v-col>
            <v-col
              cols="5"
              style="min-width: 100px;"
              class="flex-grow-0 flex-shrink-1"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                I'm 5 column wide and I shrink if there's not enough space
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card flat>
          <v-card-text>
            <v-row
              class="flex-xl-nowrap"
            >
              <v-col
                cols="24"
                md="1"
                style="max-width:500px"
              >
                <v-card
                  class="mx-auto"
                >
                  <v-toolbar
                    color="teal accent-4"
                    dark
                  >
                    <v-icon
                      small
                      class="mr-2"
                    >
                      mdi mdi-account-convert
                    </v-icon>
                    <v-toolbar-title>
                      待定
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-divider />

                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content @click="change_status">
                            <v-list-item-title>居然之家</v-list-item-title>
                            <v-list-item-subtitle>居然之家</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>梦舟集团</v-list-item-title>
                            <v-list-item-subtitle>梦舟集团</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>神州数码</v-list-item-title>
                            <v-list-item-subtitle>神州数码客户要求这个项目是２个月内完成</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>贝肯医疗</v-list-item-title>
                            <v-list-item-subtitle>贝肯医疗</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
                <v-card
                  class="mx-auto"
                >
                  <v-toolbar
                    color="light-green accent-4"
                    dark
                  >
                    <v-icon
                      small
                      class="mr-2"
                    >
                      mdi mdi-account-heart
                    </v-icon>
                    <v-toolbar-title>有效约见</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />

                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>居然之家</v-list-item-title>
                            <v-list-item-subtitle>居然之家</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>梦舟集团</v-list-item-title>
                            <v-list-item-subtitle>梦舟集团</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="1"
                style="max-width:500px"
              >
                <v-card
                  class="mx-auto"
                >
                  <v-toolbar
                    color="green accent-4"
                    dark
                  >
                    <v-icon
                      small
                      class="mr-2"
                    >
                      mdi mdi-account-star
                    </v-icon>
                    <v-toolbar-title>签约</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />

                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-alert>
                        暂无!
                      </v-alert>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="1"
                style="max-width:500px"
              >
                <v-card
                  class="mx-auto"
                >
                  <v-toolbar
                    color="yellow accent-4"
                    dark
                  >
                    <v-icon
                      small
                      class="mr-2"
                    >
                      mdi mdi-account-plus
                    </v-icon>
                    <v-toolbar-title>高意向</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />

                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>梦舟集团</v-list-item-title>
                            <v-list-item-subtitle>梦舟集团</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="1"
                style="max-width:500px"
              >
                <v-card
                  class="mx-auto"
                >
                  <v-toolbar
                    color="orange accent-4"
                    dark
                  >
                    <v-icon
                      small
                      class="mr-2"
                    >
                      mdi mdi-account-minus
                    </v-icon>
                    <v-toolbar-title>低意向</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />

                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-list-item>
                        <template>
                          <v-list-item-action
                            style="margin-right:10px;"
                          >
                            <v-menu
                              bottom
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  class="mr-2"
                                  style="font-size:24px;"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi mdi-apps
                                </v-icon>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, i) in items"
                                  :key="i"
                                  @click="() => {}"
                                >
                                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>居然之家</v-list-item-title>
                            <v-list-item-subtitle>居然之家</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="1"
                style="max-width:500px"
              >
                <v-card
                  class="mx-auto"
                >
                  <v-divider />
                  <v-list
                    subheader
                    two-line
                    flat
                  >
                    <v-toolbar
                      color="red lighten-1"
                      dark
                    >
                      <v-icon
                        small
                        class="mr-1"
                      >
                        mdi-alert-decagram
                      </v-icon>
                      <v-toolbar-title>无效</v-toolbar-title>
                    </v-toolbar>
                    <v-divider />
                    <v-list-item-group
                      v-model="settings"
                      multiple
                    >
                      <v-alert>
                        暂无!
                      </v-alert>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!--tab2-content-->
      <v-tab-item
        key="2"
        value="tab-2"
        class="pa-10"
      >
        <v-card flat>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-card-title
                class="font-weight-medium"
              >
                基本信息
              </v-card-title>
              <v-text-field
                :value="userInfo.username"
                label="用户名"
                disabled
              />

              <v-text-field
                :value="userInfo.name"
                label="姓名"
                disabled
              />

              <v-text-field
                :value="userInfo.phone"
                label="手机号"
                disabled
              />
              <v-card-title>修改密码</v-card-title>
              <v-text-field
                v-model="old_pass"
                :counter="20"
                :rules="oldpassRules"
                label="原密码"
                required
                @blur="checkUser"
              />

              <v-text-field
                v-model="password"
                :counter="20"
                :rules="passwordRules"
                label="新密码"
                type="password"
                required
              />

              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="validate"
              >
                提交
              </v-btn>

              <v-btn
                color="error"
                class="mr-4"
                @click="reset"
              >
                重置
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <!--项目详情-->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>客户详情</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="dialog = false"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list
            three-line
            subheader
          >
            <v-subheader>客户信息</v-subheader>
            <v-row
              class="spacing-playground pa-2"
            >
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>公司名称</v-list-item-title>
                    <v-list-item-subtitle>居然之家集团有限公司</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>联系人</v-list-item-title>
                    <v-list-item-subtitle>王宝强</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>联系电话</v-list-item-title>
                    <v-list-item-subtitle>13122445544</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>其他联系方式</v-list-item-title>
                    <v-list-item-subtitle>微信：ｚ001。邮箱：ｚｌｙ@lsgj.cn</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>客户类型</v-list-item-title>
                    <v-list-item-subtitle>A类</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>项目概况</v-list-item-title>
                    <v-list-item-subtitle>这个项目是公司重点案例项目，需要花时间了解客户的需求，尽全力拿下</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list>
          <v-divider />
          <v-list
            three-line
            subheader
          >
            <v-subheader>工作信息</v-subheader>
            <v-row
              class="spacing-playground pa-2"
            >
              <v-col
                cols="24"
                md="12"
              >
                <v-radio-group
                  v-model="status"
                  mandatory
                  row
                  label="结果（状态）"
                >
                  <v-radio
                    label="待定"
                    value="1"
                  />
                  <v-radio
                    label="无效"
                    value="2"
                  />
                  <v-radio
                    label="有效约见"
                    value="3"
                  />
                  <v-radio
                    label="高意向"
                    value="4"
                  />
                  <v-radio
                    label="低意向"
                    value="5"
                  />
                  <v-radio
                    label="签约"
                    value="6"
                  />
                  <v-radio
                    label="输单"
                    value="7"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                cols="24"
                md="12"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>工作日志</v-list-item-title>
                    <v-list-item-subtitle>分配给张刘洋</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="24"
                md="12"
              >
                <v-text-field
                  v-model="life_cycle"
                  label="日志"
                  outlined
                  clearable
                />
              </v-col>
            </v-row>
          </v-list>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'UserProfileView',
    data () {
      return {
        life_cycle: '',
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
        status: 0,
        uid: '',
        tab: null,
        settings: [],
        valid: true,
        old_pass: '',
        userInfo: [],
        oldpassRules: [
          v => !!v || '原密码不能为空',
        ],
        password: '',
        passwordRules: [
          v => !!v || '请输入新的密码并牢记',
          v => v.length >= 6 || '密码必须为大于等于６个字符',
          // v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        repassword: '',
        repasswordRules: [
          v => !!v || '确认密码不能为空',
          // v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        items: [
          {
            title: '待定',
          },
          {
            title: '有效约见',
          },
          {
            title: '签约',
          },
          {
            title: '高意向',
          },
          {
            title: '低意向',
          },
          {
            title: '无效',
          },
        ],
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/profile')
          .then(response => {
            if (response.data.code === 20000) {
              this.userInfo = response.data.data
              this.uid = response.data.data.id
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      validate () {
        const _this = this
        this.$refs.form.validate()
        axios
          .post(process.env.VUE_APP_BASE_API + '/admins/password', { pass: this.password })
          .then(response => {
            if (response.data.code === 20000) {
              this.$message.success(response.data.msg)
              this.old_pass = ''
              _this.$router.push('/')
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      change_status () {
        this.dialog = true
      },
      checkUser () {
        if (this.old_pass !== '') {
          axios
            .post(process.env.VUE_APP_BASE_API + '/admins/check_user', { oldpass: this.old_pass, validate: 'oldpass' })
            .then(response => {
              if (response.data.data === 'yes') {
                this.$message.error(response.data.msg)
                this.old_pass = ''
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
    },
  }
</script>
